import BaseEntity from '../../base/BaseEntity.model';
import TramiteCambioDireccion from '../cambio-direccion/cambio-direccion.model';
import TramiteLiberacionDocumento from './documento.model';

export default class TramiteLiberacion extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public sancionId?: number;
    public observacionId?: number;
    public razonId?: number;
    public razonNombre?: string;
    public razonCodigo?: string;
    public generaCambioDireccion?: boolean;
    public tramiteCambioDireccion?: TramiteCambioDireccion;

    public tipoTramiteId?: number;
    public codigoTipoTramite?: string;
    public tituloTipoTramite?: string;
    public documentos: TramiteLiberacionDocumento[];
    public razonLiberacion:any = null
    public sancion?: any;
    public observacion?: any;
    constructor() {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.generaCambioDireccion = false;
        this.tramiteCambioDireccion = undefined;
        this.sancionId = undefined;
        this.observacionId = undefined;
        this.razonId = undefined;
        this.razonNombre = undefined;
        this.generaCambioDireccion = undefined;
        this.tipoTramiteId = undefined;
        this.codigoTipoTramite = undefined;
        this.tituloTipoTramite = undefined;
        this.documentos = [];
    }
}